/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/no-named-as-default */
/* eslint-disable no-undef */
import 'core-js/stable'
import 'react-app-polyfill/ie9'
import 'react-app-polyfill/ie11'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import store from './store'
import App from './containers'

if (process.env.NODE_ENV === 'production') {
    console.log = function () {}
}

// eslint-disable-next-line no-undef
const rootElement = document.getElementById('root')
const root = createRoot(rootElement)
root.render(
    <Provider store={store}>
        <App />
    </Provider>
)

if (window.Cypress) {
    window.store = store
}
